import StickyBottom from '@/components/StickyBottom';
import styles from './index.less';
import UserInfo from '@/pages/Mine/My/components/UserInfo';
import UserMoreOperation from '@/pages/Mine/My/components/UserMoreOperation';
import MaskDialog from '@/components/MaskDialog';
import { useEffect, useState } from 'react';
import { useModel, history, Helmet } from '@umijs/max';
import { Button, Dialog, Toast } from 'react-vant';
import { logout } from '@/service/login';
import InfoHouse from './components/InfoHouse';

const Mine = () => {
  const token = localStorage.getItem('token');
  const [maskDialogVisible, setMaskDialogVisible] = useState(false);
  const { handleQueryWechatAccountInfo } = useModel('useGlobal', (model) => ({
    handleQueryWechatAccountInfo: model.handleQueryWechatAccountInfo,
  }));

  useEffect(() => {
    handleQueryWechatAccountInfo();
  }, []);

  // const openMaskDialog = () => {
  //   setMaskDialogVisible(true);
  // };

  const logoutTo = () => {
    Dialog.show({
      title: '确认要退出登录吗？',
      message: '',
      showCancelButton: true,
      onCancel: () => {
        return true;
      },
      onConfirm: async () => {
        const res = await logout();
        if (res && res.code === 200) {
          Toast.success({ message: '退出成功！' });
          localStorage.removeItem('token');
          localStorage.removeItem('userInfo');
          localStorage.removeItem('loginInfo');
          history.push('/login');
          return true;
        }
      },
    });
  };

  return (
    <div className={styles.container}>
      <Helmet>
        <title>我的</title>
      </Helmet>
      <UserInfo />
      {/* <Operation btnClick={openMaskDialog} /> */}
      <InfoHouse />
      <UserMoreOperation />
      {token && (
        <div className={styles['logout-button']}>
          <Button onClick={logoutTo} type="primary" block round>
            退出
          </Button>
        </div>
      )}
      <MaskDialog visible={maskDialogVisible} close={setMaskDialogVisible} />
      <StickyBottom activeKey={'user'} />
    </div>
  );
};

export default Mine;
